// extracted by mini-css-extract-plugin
export var active = "_tc-1";
export var circle = "_tc-0";
export var completed = "_tc-2";
export var connector = "_tc-4";
export var connectorCompleted = "_tc-7";
export var connectorSpacer = "_tc-5";
export var iconStrokeOverride = "_tc-8";
export var labelContainer = "_tc-6";
export var pending = "_tc-3";